import { Div, Link, MultipleFilesInput, Span } from "@tblabs/truffle";
import { PicturePack } from "../../../Services/PhotoStorage/PicturePack";
import { OnlineStorage } from "../../../Services/PhotoStorage/OnlineStorage";
import { Notification } from "../../Notification";
import { Box } from "../../Utils/Box";


export class PicsUploader extends Div
{
    constructor(onSuccessfulUpload?: (images: PicturePack[]) => void)
    {
        super("add-field-box");

        this.Append(
            new Div().Append(
                new Span("Dodaj wiele zdjęć").FloatLeft(),
                new Link("✖️").FloatRight().CursorPointer().OnClick(() => this.Hide()),
                new Div().ClearBoth(),
            ).Margin(8),
            new MultipleFilesInput(async (files: File[]) =>
            {
                new Notification(`Ładowanie ${files.length} zdjęć`, "W toku...");

                const storage = new OnlineStorage("https://photos.specteam.pl");

                const dir = "specteam";
                const uploadResult = await storage.UploadManyFiles(files, dir);

                new Notification(uploadResult.IsSuccess ? `✅ Załadowano ${uploadResult.PicturesPacks.length} zdjęć` : "🔴 Błąd ładowania", uploadResult.ErrorMessage);
                if (uploadResult.IsSuccess)
                    onSuccessfulUpload?.(uploadResult.PicturesPacks);
            }),
        )
    }
}

export class PicUploader extends Div
{
    constructor(onSuccessfulUpload?: (image: PicturePack) => void)
    {
        super("entry");

        this.Append(
            new Box(
                new Span("Dodaj zdjęcie").FloatLeft(),
                new Link("✖️").FloatRight().CursorPointer().OnClick(() => this.Hide()),
                new Div().ClearBoth(),
            ).Margin(8),
            new MultipleFilesInput(async (files) =>
            {
                new Notification(`Ładowanie zdjęcia`, "W toku...");

                const storage = new OnlineStorage("https://photos.specteam.pl");

                const dir = "specteam";
                const uploadResult = await storage.UploadManyFiles(files, dir);

                new Notification(uploadResult.IsSuccess ? `✅ Plik załadowany` : "🔴 Upload error", uploadResult.ErrorMessage);
                if (uploadResult.IsSuccess)
                    onSuccessfulUpload?.(uploadResult.PicturesPacks[0]);
            }),
        )
    }
}
